<template>
  <div>
    <Header></Header>
    <div class='banners'><img src='../assets/img/stemClass/banner.jpg' alt=''></div>
    <div class='content'>
      <div class='service'>
        <div class='title'><span>领军行业8年原创STEM课程体系</span></div>
        <div class='img'><img src='../assets/img/stemClass/1.jpg' alt=''></div>
      </div>
      <div class='service'>
        <div class='title'><span>4大学院12个系</span></div>
        <div class='img'><img src='../assets/img/stemClass/5.jpg' alt=''></div>
      </div>

      <div class='service'>
        <div class='title'><span>500套主题标准化科学产品</span></div>
        <div class='img'><img src='../assets/img/stemClass/6.jpg' alt=''></div>
        <div class='img'><img src='../assets/img/stemClass/7.jpg' alt=''></div>
        <div class='img'><img src='../assets/img/stemClass/8.jpg' alt=''></div>
        <div class='img'><img src='../assets/img/stemClass/9.jpg' alt=''></div>
        <div class="img"><img src="../assets/img/stemClass/11.jpg" alt=""></div>
        <div class='img'><img src='../assets/img/stemClass/10.jpg' alt=''></div>
      </div>
    </div>
    <Footer></Footer>
  </div>
</template>
<script>
import Header from '@/components/Header'
import Footer from '@/components/Footer'

export default {
  name: 'StemClass',
  components: {Header, Footer},
  data () {
    return {
      msg: 'StemClass'
    }
  }
}
</script>
<style>
  .banners{
    width:100%;
    height:auto;
    marign:0 auto;
    text-align:center;
    background:#00024C;
  }
  .banners img{
    border:1em solid white;
  }
  .content {
    width: 80%;
    height: auto;
    text-align: center;
    margin-top:2em;
  }

  .title {
    margin: 0 auto;
    text-align: center;
  }

  .title span {
    font-size: 2em;
    font-weight: bold;
    letter-spacing: 0.1em;
  }

  .service{
    width:80%;
    margin:0 auto;
    text-align: center;
    margin-bottom: 3em;
  }
  .img{
    margin-top:2em;
  }
</style>
